// React
import React from 'react';
// 三方库
import { useTranslation } from '@/i18n/client';
// 接口
import { Address } from '@/apis/address/address.interface';
// 资源
import FrozenIcon from '@/assets/icons/address/FrozenIcon.svg';
import PickupPointOpenTimeIcon from '@/assets/icons/address/PickupPointOpenTimeIcon.svg';
// 样式
import styles from './index.module.scss';

interface PickupDetailProps {
  pickupInfo: Address | null;
}

const PickupDetail: React.FC<PickupDetailProps> = ({ pickupInfo }) => {
  const { t } = useTranslation();

  if (!pickupInfo) {
    return <div className={styles.emptyDetail}></div>;
  }

  return (
    <div className={styles.pickupDetailContainer}>
      <div className={styles.pickupInfo}>
        <h2 className={styles.pickupName}>{pickupInfo.siteName}</h2>

        <p className={styles.pickupAddress}>{pickupInfo.address}</p>

        <div className={styles.tagsContainer}>
          {pickupInfo.frozenFlag && (
            <div className={styles.tagItem}>
              <FrozenIcon className={styles.tagIcon} />
              <span className={styles.tagText}>
                {pickupInfo.frozenInfo?.text || t('address.frozenSupport')}
              </span>
            </div>
          )}
        </div>

        <div className={styles.openingTimeContainer}>
          <div className={styles.openingTimeTitle}>
            <PickupPointOpenTimeIcon className={styles.sectionIcon} />
            {t('address.openingTime')}
          </div>

          <div className={styles.openingTimeList}>
            {pickupInfo?.businessHours?.map((item: string, index: number) => (
              <div key={index} className={styles.openingTimeItem}>
                {item}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PickupDetail;
